import IconButton from '@mui/material/IconButton'
import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'

interface ButtonProps {
  onClick: () => void
  title?: string
  disabled?: boolean
  children?: React.ReactNode
  dataTestId?: string
}

export const ArchiveButton: React.FC<ButtonProps> = ({ onClick, disabled = false, title = 'Archive item', children, dataTestId }) => (
  <Tooltip title={title}>
    <IconButton
      data-testid={dataTestId}
      disabled={disabled}
      onClick={onClick}
    >
      {children || <Inventory2OutlinedIcon className={disabled ? 'icon-pantoneBlue--disabled' : 'icon-pantoneBlue'} />}
    </IconButton>
  </Tooltip>
)
